<script setup>
import { terms } from '@/datas/terms'
import { useAlertDialog } from '@/utils/stores/alertDialog'
import Term2 from '@/views/admin/term2.vue'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import LoginIllustrationPetobio from '@images/petobio/login.jpg'
import { VForm } from 'vuetify/components/VForm'

// const imageVariant = useGenerateImageVariant(authV2RegisterIllustrationLight, authV2RegisterIllustrationDark, authV2RegisterIllustrationBorderedLight, authV2RegisterIllustrationBorderedDark, true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)
const imageVariant = LoginIllustrationPetobio

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const stepItems = [
  {
    title: '약관동의',

    // subtitle: '가입 구분',
    icon: 'tabler-users',
  },
  {
    title: '정보 입력',

    // subtitle: '상세 정보 입력',
    icon: 'tabler-file-text',
  },
]

const errors = ref({
  email: "",
})

const form = ref({
  username: '',
  email: '',
  password: '',
  privacyPolicies: false,
})

const refVForm = ref()
const route = useRoute()
const router = useRouter()
const alertDialogStore = useAlertDialog()
const currentStep = ref(0)
const isCurrentStepValid = ref(true)
const refTermsForm = ref()
const checkTerms = ref([])
const checkedEmail = ref(false)

const stepOneNext = computed(() => {
  return !!(checkTerms.value[1] && checkTerms.value[2])
})

const validateTermsForm = () => {
  refTermsForm.value?.validate().then(valid => {
    if (valid.valid) {
      currentStep.value++
      isCurrentStepValid.value = true
    } else {
      isCurrentStepValid.value = false
    }
  })
}

const checkEmail = async() => {
  if(!form.value.email || emailValidator(form.value.email) !== true) {
    return
  }

  const res = await $api('/auth/check-email', {
    method: 'POST',
    body: {
      email: form.value.email,
    },
  })

  if(res.result) {
    checkedEmail.value = true
    alertDialogStore.showAlertDialog("중복 확인이 완료되었습니다.")
  } else {
    alertDialogStore.showAlertDialog("이미 가입되어 있는 이메일입니다. 다시 확인하여 주시기 바랍니다.")
  }
}

const clickPanel = index => {
  if(index == 0) {
    checkTerms.value[0] = !checkTerms.value[0]
  }
}


const register = async () => {
  errors.value = []
  try {
    const res = await $api('/auth/register', {
      method: 'POST',
      body: {
        username: form.value.username,
        email: form.value.email,
        terms: checkTerms.value,

        // password: form.value.password,
      },
      onResponseError({ response }) {
        errors.value = response._data.errors
      },
    })

    alertDialogStore.showAlertDialog("발송된 이메일을 통해 비밀번호 설정 후 로그인 하세요.")

    localStorage.removeItem("projectId")
    localStorage.removeItem("projectNo")
    localStorage.removeItem("projectName")

    await nextTick(() => {
      router.replace(route.query.to ? String(route.query.to) : '/login')
    })
  } catch (err) {
    console.error(err)
  }
}

const onSubmit = () => {
  refVForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid)
      register()
  })
}

watch(() => checkTerms.value[0],
  (n, o) => {
    if(n && n != o) checkTerms.value = [n, true, true, true]
  },
)
</script>

<template>
  <div class="auth-wrapper d-flex align-center justify-center pa-4">
    <div class="position-relative my-sm-16">
      <VCard class="auth-card pa-4">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="12"
              class="auth-card-v2 d-flex align-center justify-center pa-10"
              style="background-color: rgb(var(--v-theme-surface));"
            >
              <VCard
                flat
                class="mt-12 mt-sm-0"
              >
                <AppStepper
                  v-model:current-step="currentStep"
                  :items="stepItems"
                  :direction="$vuetify.display.smAndUp ? 'horizontal' : 'vertical'"
                  icon-size="24"
                  class="stepper-icon-step-bg mb-8"
                  :is-active-step-valid="isCurrentStepValid"
                />

                <VWindow
                  v-model="currentStep"
                  class="disable-tab-transition"
                  :style="{maxInlineSize: currentStep == 0 ? '681px':'381px'}"
                >
                  <VWindowItem>
                    <VForm
                      ref="refTermsForm"
                      @submit.prevent="validateTermsForm"
                    >
                      <VRow>
                        <VCol cols="12">
                          <VExpansionPanels
                            variant="accordion"
                            class="expansion-panels-width-border"
                            density="compact"
                          >
                            <VExpansionPanel
                              v-for="(term, index) in terms"
                              :key="index"
                            >
                              <VExpansionPanelTitle @click="clickPanel(index)">
                                <template
                                  v-if="index == 0"
                                  #actions
                                />
                                <VCheckbox
                                  v-model="checkTerms[index]"
                                  @click.stop
                                />
                                {{ term.title }}
                              </VExpansionPanelTitle>
                              <VExpansionPanelText v-if="index == 1 || index ==3">
                                <div style="max-height: 300px;overflow: auto;">
                                  <span v-html="term.text" />
                                </div>
                              </VExpansionPanelText>
                              <VExpansionPanelText v-if="index == 2">
                                <Term2 />
                              </VExpansionPanelText>
                            </VExpansionPanel>
                          </VExpansionPanels>
                        </VCol>
                        <VCol cols="12">
                          <div class="d-flex flex-wrap gap-4 justify-sm-space-between justify-center mt-4">
                            <VBtn
                              color="secondary"
                              variant="tonal"
                              @click="$router.push('/login')"
                            >
                              <VIcon
                                icon="tabler-arrow-left"
                                start
                                class="flip-in-rtl"
                              />
                              로그인
                            </VBtn>

                            <VBtn
                              type="submit"
                              color="success"
                              :disabled="!stepOneNext"
                            >
                              다음
                              <VIcon
                                icon="tabler-arrow-right"
                                end
                                class="flip-in-rtl"
                              />
                            </VBtn>
                          </div>
                        </VCol>
                      </VRow>
                    </VForm>
                  </VWindowItem>
                  <VWindowItem>
                    <VForm
                      ref="refVForm"
                      @submit.prevent="onSubmit"
                    >
                      <VRow>
                        <!-- Username -->
                        <VCol cols="12">
                          <AppTextField
                            v-model="form.username"
                            :rules="[requiredValidator]"
                            autofocus
                            label="사용자명"
                          />
                        </VCol>

                        <!-- email -->
                        <VCol cols="12">
                          <AppTextField
                            v-model="form.email"
                            :rules="[requiredValidator, emailValidator]"
                            label="이메일"
                            type="email"
                            :disabled="checkedEmail"
                            :error-messages="errors.email"
                          >
                            <template #append>
                              <VBtn
                                color="success"
                                :disabled="!form.email || emailValidator(form.email) !== true"
                                @click="checkEmail"
                              >
                                중복확인
                              </VBtn>
                            </template>
                          </apptextfield>
                        </VCol>

                        <VCol cols="12">
                          <div class="d-flex flex-wrap gap-4 justify-sm-space-between justify-center mt-4">
                            <VBtn
                              v-show="currentStep != 0"
                              color="secondary"
                              :disabled="currentStep === 0"
                              variant="tonal"
                              @click="currentStep--"
                            >
                              <VIcon
                                icon="tabler-arrow-left"
                                start
                                class="flip-in-rtl"
                              />
                              돌아가기
                            </VBtn>

                            <VBtn
                              type="submit"
                              :disabled="!checkedEmail"
                            >
                              회원가입
                            </VBtn>
                          </div>
                        </VCol>
                        <VCol
                          cols="12"
                          class="text-center text-base"
                        >
                          <span>이미 계정이 있나요?</span>
                          <RouterLink
                            class="text-primary ms-2"
                            :to="{ name: 'login' }"
                          >
                            로그인으로
                          </RouterLink>
                        </VCol>
                        <!--
                          <VCol
                          cols="12"
                          class="d-flex align-center"
                          >
                          <VDivider />
                          <span class="mx-4">or</span>
                          <VDivider />
                          </VCol>
                        -->

                        <!-- auth providers -->
                        <!--
                          <VCol
                          cols="12"
                          class="text-center"
                          >
                          <AuthProvider />
                          </VCol>
                        -->
                      </VRow>
                    </VForm>
                  </VWindowItem>
                </VWindow>
              </vcard>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
      <VCard
        v-if="false"
        class="auth-card pa-4"
      >
        <VCardText>
          <!--
            <VNodeRenderer
            :nodes="themeConfig.app.logo"
            class="mb-6"
            />
          -->
          <h5 class="text-h5 mb-1 font-weight-bold">
            회원 가입
          </h5>
          <!--
            <p class="mb-0">
            Make your app management easy and fun!
            </p>
          -->
        </VCardText>

        <VCardText>
          <VForm
            ref="refVForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- Username -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.username"
                  :rules="[requiredValidator]"
                  autofocus
                  label="사용자명"
                />
              </VCol>

              <!-- email -->
              <VCol cols="12">
                <AppTextField
                  v-model="form.email"
                  :rules="[requiredValidator, emailValidator]"
                  label="이메일"
                  type="email"
                  :error-messages="errors.email"
                />
              </VCol>

              <!-- password -->
              <VCol cols="12">
                <!--
                  <AppTextField
                  v-model="form.password"
                  :rules="[requiredValidator]"
                  label="Password"
                  placeholder="············"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                  />
                -->

                <!--
                  <div class="d-flex align-center mt-2 mb-4">
                  <VCheckbox
                  id="privacy-policy"
                  v-model="form.privacyPolicies"
                  inline
                  />
                  <VLabel
                  for="privacy-policy"
                  style="opacity: 1;"
                  >
                  <span class="me-1">I agree to</span>
                  <a
                  href="javascript:void(0)"
                  class="text-primary"
                  >privacy policy & terms</a>
                  </VLabel>
                  </div>
                -->
                <span class="mx-4" />
                <VBtn
                  block
                  type="submit"
                >
                  회원가입
                </VBtn>
              </VCol>

              <!-- create account -->
              <VCol
                cols="12"
                class="text-center text-base"
              >
                <span>이미 계정이 있나요?</span>
                <RouterLink
                  class="text-primary ms-2"
                  :to="{ name: 'login' }"
                >
                  로그인으로
                </RouterLink>
              </VCol>

              <!--
                <VCol
                cols="12"
                class="d-flex align-center"
                >
                <VDivider />
                <span class="mx-4">or</span>
                <VDivider />
                </VCol>
              -->

              <!-- auth providers -->
              <!--
                <VCol
                cols="12"
                class="text-center"
                >
                <AuthProvider />
                </VCol>
              -->
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
